'use strict';

var _ = require('lodash');
var FlightThematicDataAggregationFactory = function FlightThematicDataAggregationFactory(DataAggregationFactory, ExtractMetricKeysService) {
  function FlightDataAggregation() {
    DataAggregationFactory.apply(this, arguments);
  }
  FlightDataAggregation.prototype = Object.create(DataAggregationFactory.prototype);
  FlightDataAggregation.prototype.canAggregate = function (sourceType, targetType) {
    return this.targetType === targetType && this.sourceType.indexOf(sourceType) > -1;
  };
  FlightDataAggregation.constructor = FlightDataAggregation;
  function getAggregatedCapacityPropertyName(metric, selectedReference) {
    if (selectedReference !== 'lastYear') {
      return 'physicalCapacity';
    }
    switch (metric) {
      case 'loadFactorCurrentReference':
        return 'lastYearCurrentCapacity';
      case 'loadFactorFinalReference':
        return 'lastYearFinalCapacity';
      default:
        return 'physicalCapacity';
    }
  }
  FlightDataAggregation.prototype.reduceEntriesLoadFactor = function (metrics, group, keys, reducedEntry) {
    var index, keysLength, value, aggregatedValue, multipliedValue;
    var aggregatedCapacity = {};
    _.forEach(keys, function (m) {
      aggregatedCapacity[m] = undefined;
    });
    for (var groupindex = 0, groupLength = group.length; groupindex < groupLength; groupindex++) {
      var element = group[groupindex];
      for (index = 0, keysLength = keys.length; index < keysLength; index++) {
        var aggregatedCapacityProperty = getAggregatedCapacityPropertyName(metrics[0][index], metrics[1].params.selectedReference);
        var aggregatedCapacityValue = element[aggregatedCapacityProperty];
        value = element[keys[index]];
        aggregatedValue = reducedEntry[keys[index]];
        multipliedValue = !_.isUndefined(value) && !_.isUndefined(aggregatedCapacityValue) ? value * aggregatedCapacityValue : undefined;
        if (!_.isUndefined(multipliedValue)) {
          reducedEntry[keys[index]] = !_.isUndefined(aggregatedValue) ? aggregatedValue + multipliedValue : multipliedValue;
          if (!_.isUndefined(aggregatedCapacityValue)) {
            if (_.isUndefined(aggregatedCapacity[keys[index]])) {
              aggregatedCapacity[keys[index]] = aggregatedCapacityValue;
            } else {
              aggregatedCapacity[keys[index]] += aggregatedCapacityValue;
            }
          }
        }
      }
    }
    for (index = 0, keysLength = keys.length; index < keysLength; index++) {
      aggregatedValue = reducedEntry[keys[index]];
      var aggregatedCapacityForMetric = aggregatedCapacity[keys[index]];
      if (!_.isUndefined(aggregatedValue) && !_.isUndefined(aggregatedCapacityForMetric)) {
        reducedEntry[keys[index]] = aggregatedCapacityForMetric !== 0 ? aggregatedValue / aggregatedCapacityForMetric * 100 : 0;
      } else {
        reducedEntry[keys[index]] = undefined;
      }
    }
  };
  FlightDataAggregation.prototype.getAggregationFunction = function (metrics, metricDescriptor) {
    var isLoadFactor = metrics.join('-').indexOf('loadFactor') > -1;
    return isLoadFactor ? this.reduceEntriesLoadFactor.bind(this, [metrics, metricDescriptor]) : this.reduceEntries;
  };
  FlightDataAggregation.prototype.aggregate = function (data, metrics, metricDescriptor) {
    var aggregationFunction = this.getAggregationFunction(metrics, metricDescriptor);
    var aggregationProperty = this.aggregationProperty;
    var overridingAggregationProperty = this.overridingAggregationProperty;
    var groupedData = {},
      keys,
      keysLength,
      metricKeys;
    for (var index = 0, dataLength = data.length; index < dataLength; index++) {
      var effectiveValue = data[index][overridingAggregationProperty] || data[index][aggregationProperty];
      if (Array.isArray(groupedData[effectiveValue])) {
        groupedData[effectiveValue].push(data[index]);
      } else {
        groupedData[effectiveValue] = [data[index]];
      }
    }
    keys = Object.keys(groupedData);
    if (Object.keys(groupedData).length > 0) {
      metricKeys = ExtractMetricKeysService.extract(groupedData[keys[0]][0]);
    }
    for (index = 0, keysLength = keys.length; index < keysLength; index++) {
      var reducedEntry = {};
      var time = keys[index];
      var element = groupedData[time][0];
      reducedEntry.label = element[overridingAggregationProperty] || element[aggregationProperty];
      metricKeys = ExtractMetricKeysService.extract(element);
      aggregationFunction(groupedData[time], metricKeys, reducedEntry);
      groupedData[time] = reducedEntry;
    }
    return this.sortAggregationResults(groupedData);
  };
  return FlightDataAggregation;
};
FlightThematicDataAggregationFactory.$inject = ['DataAggregationFactory', 'ExtractMetricKeysService'];
module.exports = FlightThematicDataAggregationFactory;